<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'shared.select-customer.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      customer_account_id: '',
      ...vm.value
    }
  }),
  watch: {
    value: {
      handler (val) {
        this.form = {
          ...this.form,
          ...val
        }
      },
      immediate: true,
      deep: true
    },
    'form.customer_account_id': {
      handler (customerAccountId) {
        if (!customerAccountId) return
        this.$store.commit('auth/SET_SELECTED_CUSTOMER_ACCOUNT_ID', customerAccountId)
        const payload = { customer_account_id: customerAccountId }
        this.$emit('input', payload)
        this.$emit('validated', payload)
      },
      immediate: true
    }
  },
  validations: {
    form: {
      customer_account_id: {
        required
      }
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$store.commit(
          'auth/SET_SELECTED_CUSTOMER_ACCOUNT_ID',
          this.form.customer_account_id
        )
        this.$emit('validated', {
          customer_account_id: this.form.customer_account_id
        })
        this.$emit('input', {
          customer_account_id: this.form.customer_account_id
        })
      }

      return !this.$v.form.$invalid
    }
  }
}
</script>
<template>
  <b-card no-body class="shadow-none">
    <g-form-error-wrapper :validations="$v.form.customer_account_id">
      <template>
        <app-customer-select
          v-model="form.customer_account_id"
          v-on:blur="$v.form.customer_account_id.$touch()"
        />
      </template>
    </g-form-error-wrapper>
  </b-card>
</template>
